/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_NextInputs */

const en_us2_progress_report_next = /** @type {(inputs: Progress_Report_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next period`)
};

const pt_br2_progress_report_next = /** @type {(inputs: Progress_Report_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo período`)
};

const es_419_progress_report_next = /** @type {(inputs: Progress_Report_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Período siguiente`)
};

const pt_pt2_progress_report_next = /** @type {(inputs: Progress_Report_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Período seguinte`)
};

const fr_fr2_progress_report_next = /** @type {(inputs: Progress_Report_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Période suivante`)
};

const de_de2_progress_report_next = /** @type {(inputs: Progress_Report_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächster Zeitraum`)
};

const it_it2_progress_report_next = /** @type {(inputs: Progress_Report_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periodo successivo`)
};

/**
* | output |
* | --- |
* | "Next period" |
*
* @param {Progress_Report_NextInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_next = /** @type {((inputs?: Progress_Report_NextInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_NextInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_next(inputs)
	if (locale === "es-419") return es_419_progress_report_next(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_next(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_next(inputs)
	if (locale === "de-DE") return de_de2_progress_report_next(inputs)
	if (locale === "it-IT") return it_it2_progress_report_next(inputs)
	return en_us2_progress_report_next(inputs)
});
export { progress_report_next as "progress-report.next" }